/**
 * Памʼять навігації між запусками — O5.
 *
 * Рішення, яке варто назвати вголос: **відновлюємо лише свіжий стан**.
 * Застосунок, відкритий уранці, має показати сьогодні, а не той тиждень,
 * який дивилися три дні тому. Але перезапуск через хвилину — це продовження
 * тієї самої роботи, і викидати з неї було б грубо.
 */
export const RESTORE_WINDOW_MS = 30 * 60 * 1000;

const KEY = "beresta.lastRoute";

interface Saved {
  path: string;
  at: number;
}

/** Сховище може бути недоступним — приватне вікно, вимкнені дані сайту. */
function storage(): Storage | null {
  try {
    return globalThis.localStorage ?? null;
  } catch {
    return null;
  }
}

export function rememberRoute(path: string, now: number = Date.now()): void {
  try {
    storage()?.setItem(KEY, JSON.stringify({ path, at: now } satisfies Saved));
  } catch {
    // Переповнене сховище не має ламати навігацію.
  }
}

export function recallRoute(now: number = Date.now()): string | null {
  try {
    const raw = storage()?.getItem(KEY);
    if (!raw) return null;
    const saved = JSON.parse(raw) as Saved;
    if (typeof saved.path !== "string" || typeof saved.at !== "number") return null;
    return now - saved.at <= RESTORE_WINDOW_MS ? saved.path : null;
  } catch {
    return null;
  }
}

export function forgetRoute(): void {
  try {
    storage()?.removeItem(KEY);
  } catch {
    /* нічого */
  }
}
